import {View, StyleSheet} from 'react-native';
import tableStyle from '../style';
import React from 'react';
import Text from '@/components/basic/text';
import theme from '@/style';
import {BasicObject} from '@/types';
import {toPriceStr} from '@/utils';
import {useTranslation} from 'react-i18next';
import DigitBall from '../../../digit/components/digit-ball';

const DigitsTable = ({
  list = [],
  isOpen,
}: {
  list: BasicObject[];
  isOpen?: boolean;
}) => {
  const {i18n} = useTranslation();

  // 根据结果位数生成对应的标签
  const getLabels = (resultLength: number): string[] => {
    switch (resultLength) {
      case 3:
        return ['A', 'B', 'C'];
      case 4:
        return ['Z', 'A', 'B', 'C'];
      case 5:
        return ['Y', 'Z', 'A', 'B', 'C'];
      default:
        return ['A', 'B', 'C'];
    }
  };

  const getABC = (indexCode: string) => {
    if (!indexCode) {
      const labels = getLabels(3); // 默认3位
      return labels.map(key => ({key, value: ''}));
    }
    const [alphaCodes, digitCodes] = indexCode.split('=').map(v => v.split(''));
    const codeMap = alphaCodes.reduce((a, b, i) => {
      a[b] = digitCodes[i];
      return a;
    }, {} as BasicObject);

    const labels = getLabels(alphaCodes.length);
    const result = labels.map(key => ({
      key,
      value: codeMap[key] || '',
    }));
    return result;
  };

  // 获取表头标签，基于第一个有效数据的长度
  const getHeaderLabels = (): string[] => {
    if (list.length === 0) return ['A', 'B', 'C'];

    const firstItem = list.find(item => item.indexCode);
    if (!firstItem) return ['A', 'B', 'C'];

    const alphaCodes = firstItem.indexCode.split('=')[0];
    return getLabels(alphaCodes.length);
  };

  const headerLabels = getHeaderLabels();

  return (
    <>
      <View style={[tableStyle.th]}>
        <View style={[theme.flex.flex1]}>
          <View style={[theme.flex.row, styles.container]}>
            {headerLabels.map((item, index) => (
              <DigitBall
                key={index}
                digit={item}
                color={item}
                ballSize={20}
                fontSize={10}
              />
            ))}
          </View>
        </View>
        <View style={[tableStyle.tbPayment]}>
          <Text style={[theme.font.center]}>
            {i18n.t('bets-detail.label.payment').toUpperCase()}
          </Text>
        </View>
        <View style={[theme.flex.flex1]}>
          <Text style={[tableStyle.textRight]}>
            {i18n.t('bets-detail.label.result').toUpperCase()}
          </Text>
        </View>
      </View>
      <View>
        {list.map((item, index) => {
          const abcData = getABC(item.indexCode);
          return (
            <View
              key={index}
              style={[tableStyle.td, index % 2 === 1 && tableStyle.tdGray]}>
              <View style={[theme.flex.flex1, theme.flex.row]}>
                <View
                  style={[
                    theme.flex.row,
                    theme.flex.centerByCol,
                    styles.container,
                  ]}>
                  {abcData.map((pie, i) => (
                    <DigitBall
                      key={i}
                      digit={pie.value || '*'}
                      color={pie.key}
                      ballSize={20}
                      fontSize={10}
                    />
                  ))}
                </View>
              </View>
              <View style={[tableStyle.tbPayment]}>
                <Text
                  blod
                  fontFamily="fontInter"
                  size="medium"
                  style={[theme.font.center]}>
                  {toPriceStr(item.pickAmount, {
                    fixed: 2,
                    showCurrency: true,
                    thousands: true,
                  })}
                  *{item.pickCount}
                </Text>
              </View>
              <View style={[theme.flex.flex1]}>
                <View
                  style={[
                    theme.flex.end,
                    theme.flex.row,
                    theme.flex.centerByCol,
                  ]}>
                  <View style={[theme.margin.leftxxs, theme.flex.alignEnd]}>
                    <Text>
                      {i18n.t(
                        !isOpen
                          ? 'bets-detail.label.noDraw'
                          : (item.codeWinAmount || item.winAmount) > 0
                          ? 'bets-detail.label.won'
                          : 'bets-detail.label.noWin',
                      )}
                    </Text>
                    <Text
                      color={
                        (item.codeWinAmount || item.winAmount) > 0
                          ? theme.backgroundColor.orange
                          : theme.fontColor.second
                      }
                      fontFamily="fontInter"
                      blod
                      size="medium">
                      {!isOpen
                        ? '...'
                        : toPriceStr(
                            item.codeWinAmount || item.winAmount || 0,
                            {
                              fixed: 2,
                              showCurrency: true,
                              thousands: true,
                            },
                          )}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          );
        })}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    columnGap: 2,
  },
});

export default DigitsTable;
